export interface WicketUserAgreement {
  created_at: string;
  fk_agreement_id: number;
  fk_agreement_version_id: number;
  is_given: boolean;
  fk_fan_id?: number;
}
